import { ApiClientService } from './ApiClientService';

export type Organization = {
  _id?: string;
  name?: string;
  domain?: string;
  ownerName?: string;
  isOwner?: boolean;
  subscribedUntil?: string;
};

export const getOrganization = async () => {
  return ApiClientService.getJson<Organization>(`${ApiClientService.getApiBaseUrl()}/organizations`);
};

export const getOrganizationByDomain = async (domain: string) => {
  return ApiClientService.getJson<Organization>(
    `${ApiClientService.getApiBaseUrl()}/organizations/subscription/${encodeURIComponent(domain)}`
  );
};

export const createOrganization = async (name: string, domain: string) => {
  return ApiClientService.postJson(`${ApiClientService.getApiBaseUrl()}/organizations`, {
    name,
    domain,
  });
};

export const updateOrganization = async (organizationId: string) => {
  return ApiClientService.putJson(
    `${ApiClientService.getApiBaseUrl()}/organizations/${organizationId}`,
    {}
  );
};
